<template>
    <ul v-if="languages" class="language-switch">
        <li v-for="(url, label, index) in inactiveLanguages" :key="index" class="language-switch__language" :class="getClasses(label)">
            <a class="language-switch__link" :href="url" @click.prevent="click(label, url)">{{ label }}</a>
        </li>
    </ul>

</template>

<script>

import { each } from '@/js/utils.js';

export default {
    name: 'LanguageSwitch',
    computed: {
        inactiveLanguages() {
            const inactiveLanguages = {};

            each(this.languages, (label, url) => {
                if (label !== this.language) {
                    inactiveLanguages[label] = url;
                }
            })

            return inactiveLanguages;
            // return this.languages;
        },
    },
    props: {
        languages: {
            type: Object,
            default: () => {},
        },
        language: {
            type: String
        }
    },
    methods: {
        isActive(language) {
            return language === this.language;
        },
        click(language, url) {
            if (language !== this.language) {
                this.$emit('select', language, url);
            }
        },
        getClasses(language) {
            return {
                'is-active': this.isActive(language),
            }
        }
    }
}
</script>

<style lang="scss">

@import '../scss/config';

$button-size: 32;

.language-switch {
    @include font-semibold();
    display: flex;
    flex-direction: row;
    list-style: none;
    padding: 0;
    font-size: size(font-tiny);
    z-index:2;

    &__language {
        display: inline-block;

        text-transform: uppercase;

        &.is-active {
            // placeholder
        }
    }

    &__link {
        display: inline-block;
        height: rem($button-size);
        width: rem($button-size);
        line-height: rem($button-size);
        text-align: center;
    }
}
</style>
